import { ViewModel, View } from "binder"
import { OpcEditorView } from "./opcEditor-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { IOPC } from "../IOpc";
import { ProductSelector, ProductType } from "src/erp/inventory/rawData/product/productSelector";

export class OPCEditorViewModel extends ViewModel implements IOPC, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._serverUpdater = updater;
        this.productSelector = new ProductSelector(this, ProductType.FinalGood);
        this.productSelector.onSelectionChanged = selectedProduct => this.productId = selectedProduct?.id;
    }
    GetDefaultView(): View<ViewModel> {
        return new OpcEditorView();
    }
    public getTypeId(): string {
        return "VM-1A954DC1-FCFF-4926-86E1-234417F73BD2"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set isDisable(v: boolean) { this._isDisable = v; } public get isDisable(): boolean { return this._isDisable; } private _isDisable: boolean;
    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId; } private _productId: string;
    public set productSelector(v: ProductSelector) { this._productSelector = v; } public get productSelector(): ProductSelector { return this._productSelector; } private _productSelector: ProductSelector;
    public set canEdit(v: boolean) { this._canEdit = v; } public get canEdit(): boolean { return this._canEdit; } private _canEdit: boolean;

    closePopup(result?: any) {

    }

    setProductId(id: string) {
        this.productSelector.selectById(id);
    }

    getProductId(): string {
        return this.productSelector.selectedItem?.id;
    }

    async cloneTo(opc: IOPC) {
        opc.id = this.id;
        opc.name = this.name;
        opc.code = this.code;
        opc.canEdit = this.canEdit;
        opc.setProductId(this.getProductId());
    }

    back() {
        this.closePopup(null);
    }

    async save(): Promise<void> {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت OPC');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this);
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning('امکان ثبت کد OPC تکراری وجود ندارد.', 'خطا در عملیات');
                    }
                }
                else {
                    if (this.canEdit == true) {
                        await this.messageBoxConfirmSuccess('OPC با موفقیت ویرایش شد.', 'ویرایش موفق');
                    } else {
                        await this.messageBoxConfirmSuccess('OPC با موفقیت ثبت شد. وضعیت OPC ثبت شده غیرفعال می باشد.', 'ثبت موفق');
                    }
                    this.closePopup('done');
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت OPC', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.name)) {
            result.push('نام OPC مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.code)) {
            result.push('کد OPC مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.getProductId())) {
            result.push('محصول مشخص نشده است.');
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(opc: IOPC): Promise<any>;
}

export class OPCInserter implements IServerUpdater {
    async execute(opc: IOPC): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/OpcServices/CreateOpc', {
                Name: opc.name,
                Code: opc.code,
                IsActive: opc.isDisable,
                ProductId: opc.getProductId()
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class OPCUpdater implements IServerUpdater {
    async execute(opc: IOPC): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/OpcServices/UpdateOpc', {
                OpcId: opc.id,
                Name: opc.name,
                Code: opc.code,
                IsActive: opc.isDisable,
                ProductId: opc.getProductId()
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}
